import { GetAllBones } from "@project-rouge/rg-core";
import { AddMusclesToBone } from "./index49.js";
const AddMusclesToAnatomy = (joint, aggConfig) => {
  const bones = GetAllBones(joint);
  for (const b of bones) {
    AddMusclesToBone(b, aggConfig);
  }
};
export {
  AddMusclesToAnatomy
};
//# sourceMappingURL=index48.js.map
